import { NumberOfStages } from './stages'
import { OutputTorqueNotExceeded } from './torque'
import { CommonSense } from './common-sense'

const rules = [
    OutputTorqueNotExceeded,
    NumberOfStages,
    CommonSense
]

export default rules